import { render, staticRenderFns } from "./PreparationMoods.vue?vue&type=template&id=55cac902&scoped=true&"
import script from "./PreparationMoods.vue?vue&type=script&lang=js&"
export * from "./PreparationMoods.vue?vue&type=script&lang=js&"
import style0 from "./PreparationMoods.vue?vue&type=style&index=0&id=55cac902&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55cac902",
  null
  
)

export default component.exports